import http from '@/api/common'

export default {
  getDocumentUploads(workOrderId) {
    return http.get('ConnectSync/DocumentUploads', { params: { workOrderId } })
  },
  getConnectDocumentTypes() {
    return http.get('ConnectSync/DocumentTypes')
  },
  resendDocumentUpload(id) {
    return http.post(`ConnectSync/ResendDocumentUpload?id=${id}`)
  },
  getDocumentPreview(workOrderId, documentTypeId) {
    return http.get('ConnectSync/DocumentPreview', {
      params: { workOrderId, documentTypeId },
      responseType: 'blob'
    })
  },
  getStatusSyncs(workOrderId) {
    return http.get('ConnectSync/StatusSyncs', { params: { workOrderId } })
  },
  resendStatusSync(id) {
    return http.post(`ConnectSync/ResendStatusSync?id=${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/connectsync.js